import BaseGameSettings from "Engine/base/settings/BaseGameSettings";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";
import EntryPoint from "Engine/EntryPoint";
import SoundManager from "Engine/soundManager/SoundManager";

export default new class GameSettings extends BaseGameSettings {
    constructor() {
        super();
        this.data = JSON.parse(localStorage.getItem('icarusWilds')) || {
            soundMute: false,
            musicMute: false,
            quickSpin: false,
            introScreen: true
        };
    }

    init() {
        GlobalDispatcher.dispatch('gameSettings:init');
        EntryPoint.GameSettings = this;
        this.addListeners();

        for(let param in this.data) {
            this[param] = this.data[param];
        }
    }

    get soundMute() {
        return this._soundMute;
    }

    set soundMute(value) {
        this._soundMute = value;
        SoundManager.muteGroup('default', this.soundMute);
        GlobalDispatcher.dispatch('gameSettings:soundMute', this.soundMute);

        this.data.soundMute = this._soundMute;
        localStorage.setItem('icarusWilds', JSON.stringify(this.data));
    }

    get musicMute() {
        return this._musicMute;
    }

    set musicMute(value) {
        this._musicMute = value;
        SoundManager.muteGroup('music', this.musicMute);
        GlobalDispatcher.dispatch('gameSettings:musicMute', this.musicMute);

        this.data.musicMute = this._musicMute;
        localStorage.setItem('icarusWilds', JSON.stringify(this.data));
    }

    get quickSpin() {
        return this._quickSpin;
    }

    set quickSpin(value) {
        this._quickSpin = value;
        GlobalDispatcher.dispatch('gameSettings:quickSpin', this.quickSpin);

        this.data.quickSpin = this._quickSpin;
        localStorage.setItem('icarusWilds', JSON.stringify(this.data));
    }

    get introScreen() {
        return this._introScreen;
    }

    set introScreen(value) {
        this._introScreen = value;
        GlobalDispatcher.dispatch('gameSettings:introScreen', this.introScreen);

        this.data.introScreen = this._introScreen;
        localStorage.setItem('icarusWilds', JSON.stringify(this.data));
    }
}